"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    MediaVaultBatchRoute: Symbol("MediaVaultBatchRoute"),
    MediaVaultBatchClient: Symbol("MediaVaultBatchClient"),
    MediaVaultRoute: Symbol("MediaVaultRoute"),
    MediaVaultProcessingProviderSettingsClient: Symbol("MediaVaultProcessingProviderSettingsClient"),
    MediaVaultProcessingProviderSettingsRoute: Symbol("MediaVaultProcessingProviderSettingsRoute"),
    MediaVaultClient: Symbol("MediaVaultClient"),
    MediaVaultSettingsRoute: Symbol("MediaVaultSettingsRoute"),
    MediaVaultSettingsClient: Symbol("MediaVaultSettingsClient"),
    MediaVaultStreamsRoute: Symbol("MediaVaultStreamsRoute"),
    MediaVaultStreamsClient: Symbol("MediaVaultStreamsClient")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.MediaVaultStreamsRoute).to(_1.MediaVaultStreamsRoute);
    bind(TYPES.MediaVaultStreamsClient).to(_1.MediaVaultStreamsClient);
    bind(TYPES.MediaVaultBatchRoute).to(_1.MediaVaultBatchRoute);
    bind(TYPES.MediaVaultBatchClient).to(_1.MediaVaultBatchClient);
    bind(TYPES.MediaVaultSettingsRoute).to(_1.MediaVaultSettingsRoute);
    bind(TYPES.MediaVaultSettingsClient).to(_1.MediaVaultSettingsClient);
    bind(TYPES.MediaVaultProcessingProviderSettingsRoute).to(_1.MediaVaultProcessingProviderSettingsRoute);
    bind(TYPES.MediaVaultProcessingProviderSettingsClient).to(_1.MediaVaultProcessingProviderSettingsClient);
    bind(TYPES.MediaVaultRoute).to(_1.MediaVaultRoute);
    bind(TYPES.MediaVaultClient).to(_1.MediaVaultClient);
});
exports.diModule = diModule;
